<div class="row justify-content-center mt-5 mb-5" *ngIf="!dataLoaded">
    <mat-spinner [diameter]="'70'" [color]="'warn'"></mat-spinner>
</div>
<div class="container" class="m-5" *ngIf="propertyList.length == 0">
    <div class="row">
        <div class="col-sm-12">
            <h1 class="info-text">No Expired Properies.</h1>
        </div>
    </div>
</div>
<div class="container" class="m-5" *ngIf="propertyList.length > 0">
    <div class="card mb-3" *ngFor="let property of propertyList">
        <div class="card-horizontal">
            <div class="img-square-wrapper">
                <img *ngIf="property.featuredImage" [src]="property.featuredImage" class="Card image cap w-100 h-100">
                <img *ngIf="!property.featuredImage" src="assets/placeholder-image.png" class="Card image cap w-100 h-100">
            </div>
            <div class="card-body">
                <h5 style="width:93%;" class="card-title">{{ property.title }}</h5>
                <small><img src="assets/signs.png" style="height: 16px; width: 15px;"> {{ property.address }}</small>
                <hr class="divider">
                <div class="row">
                    <div class="col-12">
                        <p><strong>Total Ad Views : </strong> {{ property.totalView }}</p>
                        <p class="price"><strong>Price : </strong> NRS {{ property.price }}</p>
                        <p><strong>Expired On : </strong> {{ property.expiryDate }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center">
            <p><strong>Property Type : </strong>{{ property.PropertyType.type }}</p>
            <div clas="facilities">
                <img class="facility-images" src="assets/electricity.png" *ngIf="property.electricity == 'Available'">
                <img class="facility-images" src="assets/water-supply.png" *ngIf="property.waterSupply == 'Available'">
                <img class="facility-images" src="assets/gas-supply.png" *ngIf="property.gasSupply == 'Available'">
                <img class="facility-images" src="assets/telecommunication.png" *ngIf="property.telecommunication == 'Available'">
                <img class="facility-images" src="assets/sign.png" *ngIf="property.parking == 'Available'">
            </div>
        </div>
    </div>
</div>